import { Component, Input, OnInit } from "@angular/core";

import * as CustomEditor from "../../../assets/ckeditor5/ckEditor";

@Component({
  selector: "ngx-view-document",
  styleUrls: ["./view-document.component.scss"],
  templateUrl: "./view-document.component.html",
})
export class ViewDocumentComponent implements OnInit {
  @Input() content: string;
  config = {
    toolbar: {
      items: [],
      image: {},
    },
  };
  constructor() {}

  ngOnInit(): void {}

  //CKEditor5
  public Editor = CustomEditor;
}
